<template lang="pug">
  v-dialog(v-model="showPortionCountDialog" v-if=showPortionCountDialog width="600" :fullscreen="$vuetify.breakpoint.smAndDown" scrollable persistent)
    v-card.d-flex.flex-column(flat )
        v-card-title {{searchTerm}}
        v-card-text.pb-1.flex-shrink-0.flex-grow-1.card-body.title
            v-row.text-center()
              v-col(cols="12" align="center")
                v-text-field(type="number" v-model="portion" outlined :label="$t('orderPage.portionCount')" autofocus clearable clear-icon="fas fa-times" )
        v-divider
        v-card-actions
          v-btn(color="primary" @click="onSubmitButtonClick" :loading="inProgress") {{ $t('boarderGroupEditorDialog.portionsNullButtonLabel') }}
          v-spacer
          v-btn(color="primary" text @click="onCancelButtonClick" :disabled="inProgress") {{ $t('addBoarderDialog.closeButtonLabel') }}
          v-btn(color="primary" @click="onSubmitButtonClick" :loading="inProgress") {{ $t('boarderGroupEditorDialog.saveButtonLabel') }}

</template>

<script lang="ts">

import {Component, Prop} from "vue-property-decorator";
import Vue from 'vue';

@Component({})

export default class PortionCountDialog extends Vue {

  @Prop({ type: Boolean, default: false }) readonly showPortionCountDialog!: boolean
  @Prop({type: String}) searchTerm!: string
  @Prop({type: String}) portionsCount!: string

  private inProgress: boolean = false
  private portion: string | null = null

  onSubmitButtonClick (): void {
    this.inProgress = true
    this.$emit('save',this.portion)
  }

  onCancelButtonClick (): void {
    this.$emit('close')
  }

  mounted() {
    if(this.portionsCount != null) {
      this.portion = this.portionsCount
    }
  }

}

</script>

<style lang="stylus" scoped>

</style>
